const convertToChosen = (data) => {
  return data.filter(d => {
    if(d === null) return false
    return true
  }).map(d => {
    return {
      'value': d,
      'text': d
    }
  })
}

export default ({
  namespaced: true,
  state: {},
  getters: {
    recommendations: (state, getters, rootState) => {
      return rootState.recommendations.filter(function(r) {
        return r.service !== 'Medical Inspections'
      })
    },
    publishYears: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => new Date(r.publishedDate).getFullYear()))].sort().reverse())
    },
    services: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => r.service))].sort())
    },
    topics: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => r.topic))].sort())
    },
    associatedEntities: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(e => e.entity))].sort())
    },
    reports: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => r.report))].sort())
    },
    reportNumbers: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => r.reportNumber))].sort())
    },
    recommendationNumbers: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(r => r.number))].sort())
    },
    implementationStatuses: (state, getters) => {
      return convertToChosen([...new Set(getters.recommendations.map(s => s.implementationStatus))].sort())
    },
    filterValues: (state, getters) => {
      return {
        publishYears: getters.publishYears,
        services: getters.services,
        topics: getters.topics,
        associatedEntities: getters.associatedEntities,
        reports: getters.reports,
        reportNumbers: getters.reportNumbers,
        recommendationNumbers: getters.recommendationNumbers,
        implementationStatuses: getters.implementationStatuses,
      }
    },
  },
  actions: {},
  mutations: {}
})
